module.exports = "/src/views/player/help/images/arena2.jpg";